import { createContext } from 'preact';
export const SDKContext = createContext(null);
